/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import React from 'react';
import { render } from 'storyblok-rich-text-react-renderer';

import ColumnContent from 'components/shared/column-content';

const ColumnContentBlock = ({ blok }) => (
  <div className="container" id={blok.content_id || blok._uid}>
    {blok?.blocks?.map(
      ({ _uid, title, text, lead_text, is_h1, equal_grid, switch_column, more_content }) => {
        const renderedText = render(text);
        const renderedLeadText = render(lead_text);
        const renderedMoreText = render(more_content);
        return (
          <ColumnContent
            key={_uid}
            title={title}
            text={renderedText}
            leadText={renderedLeadText}
            isHeading={is_h1}
            equalColumnSize={equal_grid}
            switchColumn={switch_column}
            moreContent={renderedMoreText}
            isAnimated={blok.animate}
          />
        );
      }
    )}
  </div>
);

export default ColumnContentBlock;

ColumnContentBlock.propTypes = {
  blok: PropTypes.object.isRequired,
};
